import { render, staticRenderFns } from "./LoginPage.vue?vue&type=template&id=60766bff&scoped=true&"
import script from "./LoginPage.vue?vue&type=script&lang=js&"
export * from "./LoginPage.vue?vue&type=script&lang=js&"
import style0 from "./LoginPage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LoginPage.vue?vue&type=style&index=1&id=60766bff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60766bff",
  null
  
)

export default component.exports